import React, { useEffect } from "react";
import LoginNavbar from "./LoginNavbar";
import RegistrationPage from "./RegistrationPage";
import { useHistory } from "react-router-dom";

export default function Register() {
  const history = useHistory();

  useEffect(() => {
    const itemStr = localStorage.getItem("userData");
    if (itemStr) {
      history.push("/");
    }
  }, []);
  return (
    <div>
      <LoginNavbar />
      <RegistrationPage />
    </div>
  );
}
